import { useState } from 'react'
import { BotsTab } from './BotsTab'
import { FillsPanel } from './FillsPanel'
import { TradeTape } from './TradeTape'
import type { Contract, Fill, Trade } from '../types'

/**
 * Sağ alt panel — sekmeli.
 *
 *   Eşleşmeler  · piyasanın gerçek eşleşmeleri (gölge dolumlarımız `Gölge`
 *                 sütununda işaretli, ayrı satır olarak eklenmez)
 *   İşlemlerim  · Gerçekleşen İşlemlerim — yalnız dolumlarımız
 *   Botlar      · bot durumları (Adım 3)
 *
 * Emir açma (`Yeni Teklif`) ve açık emir yönetimi burada DEĞİL: ikisi de emir
 * defteri panelindeki `Emirlerim` sekmesinde. Emrin hayat döngüsü orada,
 * gerçekleşen sonuç burada.
 *
 * Panel kabuğunu (çerçeve, sekme şeridi) burası tutuyor; sekme içerikleri
 * yalnız kendi gövdelerini render ediyor.
 */

interface Props {
  trades: Trade[]
  fills: Fill[]
  contract: string | null
  contracts: Contract[]
}

type TabId = 'trades' | 'mine' | 'bots'

const TABS: { id: TabId; label: string }[] = [
  { id: 'trades', label: 'Eşleşmeler' },
  { id: 'mine', label: 'İşlemlerim' },
  { id: 'bots', label: 'Botlar' },
]

export function ActivityPanel({ trades, fills, contract, contracts }: Props) {
  const [active, setActive] = useState<TabId>('trades')

  return (
    <div className="panel">
      <div className="panel-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active === tab.id}
            className={`panel-tab${active === tab.id ? ' active' : ''}`}
            onClick={() => setActive(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {active === 'trades' && <TradeTape trades={trades} fills={fills} />}
      {active === 'mine' && <FillsPanel contract={contract} fills={fills} />}
      {active === 'bots' && <BotsTab contract={contract} contracts={contracts} />}
    </div>
  )
}
